export enum HorizontalMenuItemsKey {
  Dashboard = "dashboard",
  Profile = "profile",
  Processes = "processes",
  Policies = "policies",
  Incidents = "incidents",
  Actions = "actions",
  WellBeing = "well-being",
  Notifications = "notifications",
  Contact = "contact",
}
